import z from "zod";
import GreetingOccasionCategoryService from "../../../../services/GreetingOccasionCategoryService";
import { mapErrorsToFields } from "../../../../utils";

const api = new GreetingOccasionCategoryService();
export type State = {
  message: string | null;
  errors?: {
    name?: string[];
    general?: string[];
  };
  success: boolean;
  defaultValues: {
    name?: string;
  };
};

const FormSchema = z.object({
  name: z.string().min(1, { message: "Name is required." }),
});

export async function createGreetingOccasionCategory(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() || "",
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to create greeting occasion category.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.createGreetingOccasionCategory(validatedFields.data);
    if (result.status === 201)
      return {
        errors: {},
        message: "Greeting Occasion Category created successfully.",
        defaultValues,
        success: true,
      };
    else if (result.status === 400)
      return {
        errors: {},
        message: result.data.description,
        defaultValues,
        success: false,
      };
  } catch (error) {
    console.error("Error creating greeting occasion category:", error);
  }
  return {
    errors: {},
    message: "Failed to create greeting occasion category.",
    defaultValues,
    success: false,
  };
}

export async function updateGreetingOccasionCategory(
  id: string,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() || "",
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to update greeting occasion category.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.updateGreetingOccasionCategory({
      id: parseInt(id),
      ...validatedFields.data,
    });
    if (result.status === 204)
      return {
        errors: {},
        message: "Greeting Occasion Category updated successfully.",
        defaultValues,
        success: true,
      };
  } catch (error) {
    console.error("Error updating greeting occasion category:", error);
  }
  return {
    errors: {},
    message: "Failed to update greeting occasion category.",
    defaultValues,
    success: false,
  };
}

export async function deleteGreetingOccasionCategory(
  id: string
): Promise<{ success: boolean }> {
  try {
    const result = await api.deleteGreetingOccasionCategory(parseInt(id));
    return { success: result.status === 204 };
  } catch (error) {
    console.error("Database Error:", error);
  }
  return { success: false };
}

